<template>
  <div class="dictindex">
    <el-card class="box-card">
      <!-- card header -->
      <div slot="header" class="clearfix">
        <span>招聘信息列表</span>
        <el-button
          class="tz-r tz-create-btn"
          type="primary"
          round
          @click="jump('/recruit/create')"
          >创建招聘信息</el-button
        >
      </div>
      <!-- card header -->

      <!-- card content -->
      <!-- 筛选 -->
      <el-row>
        <el-col :span="5">
          <el-input
            placeholder="请输入职位名称"
            v-model="queryParams.jobTitle"
            clearable
            class="input-with-select"
          >
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="dictSearch"
            ></el-button>
          </el-input>
        </el-col>
      </el-row>
      <!-- 筛选 -->

      <!-- 表格 -->
      <TzTable :tableData="dictList" :columns="columns" />
      <!-- 表格 -->

      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryParams.pageNum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
      <!-- 分页 -->
      <!-- card content -->
    </el-card>
    <!-- card -->

    <!-- 编辑弹框 -->
    <!-- <Edit
      :state="editState"
      @close="editState = false"
      :row="editUnit"
      @confirm="changeDict"
    /> -->
    <!-- 编辑弹框 end -->
  </div>
</template>

<script>
import { pageList, deleteList } from '@/api/recruit'
import TzTable from '@/components/tz-table/Index.vue'
// import Edit from './components/Edit'
export default {
  components: {
    TzTable
    // Edit
  },
  data() {
    return {
      page: 1, //当前页
      size: '10',
      total: 100,
      dictTypeValue: '',
      editState: false,
      editUnit: {},
      dictList: [],
      radioStatus: null, // 1是;2否
      queryParams: {
        pageSize: '10',
        pageNum: 1,
        jobTitle: null
        // pushMp: null,
        // pushMpFlag: null,
        // pushOfficialWebsite: null,
        // pushOfficialWebsiteFlag: null
      },
      radioOptions: [
        { value: 1, label: '是' },
        { value: 2, label: '否' }
      ],
      typeOptions: [
        { value: 1, label: '轮播图' },
        { value: 2, label: 'logo' }
      ],
      columns: [
        {
          field: 'sort',
          title: '排序',
          width: '100'
        },
        {
          field: 'jobTitle',
          title: '职位名称'
        },
        {
          field: 'jobDescription',
          title: '岗位职责'
        },
        {
          field: 'content',
          title: '任职要求'
        },
        {
          field: 'location',
          title: '工作地点'
        },
        {
          field: 'salaryRange',
          title: '薪资范围'
        },
        // {
        //   field: 'experienceRequired',
        //   title: '所需的工作经验年限'
        // },
        // {
        //   field: 'educationRequired',
        //   title: '所需的最低学历'
        // },
        // {
        //   title: '图片',
        //   width: 100,
        //   type: 'photoPreview',
        //   payload: {
        //     field: 'imagePath'
        //   }
        // },

        // {
        //   title: '状态',
        //   type: 'switch',
        //   payload: {
        //     field: 'deactive',
        //     change: (row) => this.changeUnitState(row)
        //   }
        // },
        {
          title: '操作',
          width: '160',
          type: 'btn',
          payload: [
            {
              name: '编辑',
              type: 'primary',
              click: (row) => {
                console.log('编辑', row)
                // this.editUnit = JSON.parse(JSON.stringify(row))
                // // 显示弹框
                // this.editState = true
                this.$router.push({
                  path: '/recruit/Create',
                  query: { id: row.id }
                })
              }
            },
            {
              name: '删除',
              type: 'danger',
              click: (row) => {
                console.log('删除', row)
                this.deleteFn(row)
              }
            }
          ]
        }
      ]
    }
  },
  methods: {
    handleSizeChange(val) {
      this.queryParams.pageSize = val
      this.getDictList()
    },
    handleCurrentChange(val) {
      this.queryParams.pageNum = val
      this.getDictList()
    },
    // 列表
    getDictList() {
      // this.$loading({
      //   text: '查询中'
      // })

      pageList(this.queryParams).then((res) => {
        if (res.code == 200) {
          // this.$loading().close()
          console.log(res, '列表')
          let dictArr = res.data.records
          this.total = res.data.total
          // 过滤掉类型为logo和轮播图
          let dictList = dictArr.filter(
            (item) => item.type != 1 && item.type != 2
          )
          dictList.forEach((item) => {
            item.type =
              Number(item.type) == 3
                ? '检测检查'
                : Number(item.type) == 4
                ? '机管家'
                : Number(item.type) == 5
                ? '智能终端'
                : ''
          })
          this.dictList = dictList
        }
        // else {
        //   this.$loading().close()
        // }
      })
    },

    // 删除
    deleteFn(row) {
      this.$confirm('确认删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let delparams = {
            id: row.id
          }
          deleteList(delparams).then((res) => {
            console.log(res, '删除')
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              })
              this.getDictList()
            } else {
              this.$message({
                type: 'error',
                message: '删除失败!'
              })
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },

    // 模糊查询
    dictSearch() {
      this.queryParams.pageNum = 1
      this.getDictList()
    },
    // radio选择
    radioChange(el, type) {
      console.log(el, '当前选择')
      this.queryParams.pageNum = 1
      this.queryParams[type] = el
      this.getDictList()
    }
  },
  mounted() {
    this.getDictList()
  }
}
</script>

<style></style>
